import services from './services.js';
//组件
import followUpDialog from 'follow-up-dialog';
import editDialog from '@pages/CRMAgentManage/components/edit-dialog/index.vue';
import complexSearch from '@pages/CRMAgentManage/components/complex-search/index.vue';
import applyDialog from '@pages/CRMAgentManage/components/apply-dialog/index.vue';
import selectStaffDialog from 'selectStaffDialog';
import { AgentTransfer } from '@api/agentApi.js';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';

export default {
    mixins: [services],
    components: {
        selectStaffDialog,
        'follow-up-dialog': followUpDialog,
        'edit-dialog': editDialog,
        'complex-search': complexSearch,
        'apply-dialog': applyDialog
    },
    data() {
        return {
            /* 主表数据 */
            loading: false,
            isReadOnlyLook: false,
            transferVisiable: false,
            transferForm: {},
            selectEmployeeName: "",
            lists: [], //表格内容
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [], //列表选中
            /* 意向客户编辑对话框 */
            editDialogVisiable: false,
            modifyDialogVisiable: false,
            editData: null,
            currentcustomerId: null,
            /* 跟进情况列表 */
            followUpListVisiable: false,
            followUpList: [], //列表数据
            followUpTotalSize: 0, //列表总条数
            currentId: null,
            followItem: {},
            /* 高级搜索 */
            searchVisiable: false,
            filterData: {},
            /* 申请转正 */
            applyDialogVisiable: false
        }
    },
    methods: {
        transfer(row) {
            this.transferForm.company = "";
            this.selectEmployeeName = "";
            this.transferForm.company = row.Customer;
            this.transferForm.CustomerId = row.Id;
            this.transferVisiable = true;
        },
        showEmployeeDialog() {
            this.$refs.refSelectStaffDialog.show();
        },
        selectedStaff(obj) {
            this.selectEmployeeName = obj.name;
            this.transferForm.EmployeeId = obj.ID;
        },
        transferSubmit() {

            AgentTransfer({
                "CustomerId": this.transferForm.CustomerId,
                "EmployeeId": this.transferForm.EmployeeId
            }).then(res => {
                util.doResult(this, res, () => {
                    if (res.data.StateCode == 0) {
                        this.$notify({
                            title: '提示',
                            message: '转移成功!',
                            type: 'success'
                        });
                        this.transferVisiable = false;
                        this.getList();
                    }
                });
            });
        },
        showDetails(rowId) {
            this.isReadOnlyLook = true;
            this.currentcustomerId = rowId;
            this.getAgent();
        },
        //分页选定行
        handleSizeChange: function(val) {
            this.pageSize = val;
            this.getList();
        },
        //分页监听dd页面
        handleCurrentChange: function(val) {
            this.pageIndex = val;
            this.getList();
        },
        //打开跟进情况列表
        checkFollowUpList(id) {
            this.currentId = id;
            this.getFollowList({ id: id }); //跟进情况列表
            //this.followUpListVisiable = true;
        },
        //更新跟进情况列表
        refreshFollowUpList(type, val) {
            let options = {
                id: this.currentId
            };
            options[type] = val;
            this.getFollowList(options);
        },
        openEditDialog() {
            this.editDialogVisiable = true;
            this.$refs.editdialog.resetForm();
        },
        goToModify(rowId) {
            this.currentcustomerId = rowId;
            this.getAgent();
        },
        closeModifyDialog() {
            this.isReadOnlyLook = false;
        },
        closeEditDialog() {
            this.editDialogVisiable = false;
            this.modifyDialogVisiable = false;
        },
        selectRow(row) {
            if (!row) return;
            this.currentcustomerId = row.Id;
        },
        toggleSearch() {
            this.searchVisiable = !this.searchVisiable;
        },
        complexSearch(data) {
            this.filterData = data;
            this.getList();
        },
        resetFilterData() {
            this.filterData = {};
        },
        setMajor(IntentionOrMajor) {
            let noChoiceHint = (IntentionOrMajor === 0) ? '请先选择要设为意向的客户' : '请先选择要设为重点的客户';
            let confirmHint = (IntentionOrMajor === 0) ? '确认要把该客户设为意向客户？' : '确认要把该客户设为重点客户？';
            if (this.currentcustomerId === null) {
                this.$notify({
                    title: '警告',
                    message: noChoiceHint,
                    type: 'warning'
                });
                return;
            }
            this.$confirm(confirmHint, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.setAgentIntentionOrMajor(IntentionOrMajor);
            }).catch(() => {});
        },
        showApplyDialog(rowId) {
            if (rowId) {
                this.currentcustomerId = rowId;
            }
            if (this.currentcustomerId === null) {
                this.$notify({
                    title: '警告',
                    message: '请先选择要申请转正的客户',
                    type: 'warning'
                });
                return;
            }
            this.applyDialogVisiable = true;
        }
    },
    computed: {
        sysSid: function() {
            return this.$store.state.sysSid;
        },
        sysSession: function() {
            return this.$store.state.sysSession;
        },
        arrowClass() {
            return {
                'el-icon-arrow-down': !this.searchVisiable,
                'el-icon-arrow-up': this.searchVisiable
            };
        },
        bgStyle() {
            if (this.searchVisiable) {
                return {
                    'backgroundColor': '#e8e8e8'
                };
            }
            return {
                'backgroundColor': '#fff'
            };
        }
    },
    //组件初始化
    created() {
        this.getList();
    }
}


// WEBPACK FOOTER //
// ./src/pages/ViewCRMAgentManage/vm.js